export default __webpack_public_path__ + "static/media/hair-1-3.efb4c77b.svg";